// MOMKIS - Panier latéral : comportements additionnels NON couverts par
// Dawn (assets/cart-drawer.js, assets/global.js). Ne réimplémente jamais
// l'ouverture/fermeture/focus trap/Escape (déjà gérés nativement par
// <cart-drawer>) ni la mise à jour de quantité/suppression de ligne (déjà
// gérées nativement par <cart-drawer-items> / <quantity-input> /
// <cart-remove-button>). Les cartes cross-sell (snippets/momkis-cart-
// upsell-card.liquid) sont de simples liens "Voir le produit" vers le PDP :
// aucun ajout panier ni sélecteur de variante ici, donc aucun JS à leur
// attacher.

(function () {
  // Garde-fou : le bloc d'avis Judge.me qui apparaissait dans le panier
  // venait de leur propre app embed "Cart Drawer Widget"
  // (shopify://apps/judge-me-reviews/blocks/cart_drawer_widget/...), déjà
  // désactivé côté config/settings_data.json — la vraie correction. Ce
  // filet ne fait rien en temps normal ; il ne sert qu'à retirer un
  // éventuel résidu (cache navigateur/CDN pas encore purgé, ou embed
  // réactivé par erreur plus tard) STRICTEMENT à l'intérieur du panier,
  // sans jamais toucher au badge ni au carrousel Judge.me de la PDP (hors
  // scope de <cart-drawer>).
  function removeStrayJudgeme(root) {
    root.querySelectorAll('[class*="jdgm-"]').forEach(function (el) {
      el.remove();
    });
  }

  function enhance(root) {
    removeStrayJudgeme(root);
  }

  function init() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    enhance(cartDrawer);

    // <cart-drawer-items> remplace tout .drawer__inner à chaque ajout/
    // suppression/changement de quantité (voir assets/cart-drawer.js,
    // assets/global.js) : ce garde-fou doit donc être ré-appliqué à chaque
    // mutation.
    new MutationObserver(function () {
      enhance(cartDrawer);
    }).observe(cartDrawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
